import { Aurelia, PLATFORM } from 'aurelia-framework';
export function configure(aurelia: any) {
	aurelia
		.globalResources(PLATFORM.moduleName("./blur-on-enter"))
		.globalResources(PLATFORM.moduleName("./auto-focus"))
		.globalResources(PLATFORM.moduleName("./mdx-no-collapse"));
	//.globalResources(PLATFORM.moduleName('./draggable'))
	//.globalResources(PLATFORM.moduleName('./resizable'));
}